import React from "react";

export const ProjectsContext = React.createContext({});
